import i18next from "i18next";

import { createColumn } from "../../../../components/Table";

export const desktopTableColumns = [
  createColumn({
    keyName: "title",
    header: () => i18next.t("patientPage_columns_subject"),
    cell: (info) => info.renderValue(),
    size: 250,
  }),
  createColumn({
    keyName: "lastMessage",
    header: () => i18next.t("patientPage_columns_last_message"),
    cell: (info) => info.renderValue(),
    size: 280,
  }),
  createColumn({
    // The "action" in the name is load-bearing: Table.tsx treats a cell whose id contains it as an
    // action cell, which keeps it from rendering a "-" placeholder and from being dimmed for
    // archived patients. The open state renders a button, not a value.
    keyName: "statusAction",
    header: () => i18next.t("patientPage_columns_status"),
    cell: (info) => info.renderValue(),
    size: 140,
  }),
  createColumn({
    keyName: "lastUpdated",
    header: () => i18next.t("patientPage_messages_table_sent"),
    cell: (info) => info.renderValue(),
    size: 120,
  }),
  createColumn({
    keyName: "createdBy",
    header: () => i18next.t("patientPage_columns_created_by"),
    cell: (info) => info.renderValue(),
    size: 100,
  }),
];
